import React from 'react';
import { StyleSheet, View } from 'react-native';

import { goBackOrLanding } from '../../core/navigation/navigationRef';
import { colors } from '../../core/theme/tokens';
import { MarketingBackBar } from '../Landing/MarketingBackBar';
import { SettingsModalContent } from './SettingsModalContent';

/** Full-screen Settings — subscription, notifications, household, delete account. */
export function SettingsScreen() {
  return (
    <View style={styles.root}>
      <MarketingBackBar title="Settings" />
      <SettingsModalContent onClose={goBackOrLanding} />
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: colors.background,
  },
});
